export enum caStateCode {
  AB = 'AB',
  BC = 'BC',
  MB = 'MB',
  NB = 'NB',
  NL = 'NL',
  NT = 'NT',
  NS = 'NS',
  NU = 'NU',
  ON = 'ON',
  PE = 'PE',
  QC = 'QC',
  SK = 'SK',
  YT = 'YT'
}

export const caStateCodeToNameMap = {
  [caStateCode.AB]: 'Alberta',
  [caStateCode.BC]: 'British Columbia',
  [caStateCode.MB]: 'Manitoba',
  [caStateCode.NB]: 'New Brunswick',
  [caStateCode.NL]: 'Newfoundland and Labrador',
  [caStateCode.NT]: 'Northwest Territory',
  [caStateCode.NS]: 'Nova Scotia',
  [caStateCode.NU]: 'Nunavut',
  [caStateCode.ON]: 'Ontario',
  [caStateCode.PE]: 'Prince Edward Island',
  [caStateCode.QC]: 'Quebec',
  [caStateCode.SK]: 'Saskatchewan',
  [caStateCode.YT]: 'Yukon Territory'
}

export const caStates = [
  { value: caStateCode.AB, label: caStateCodeToNameMap.AB },
  { value: caStateCode.BC, label: caStateCodeToNameMap.BC },
  { value: caStateCode.MB, label: caStateCodeToNameMap.MB },
  { value: caStateCode.NB, label: caStateCodeToNameMap.NB },
  { value: caStateCode.NL, label: caStateCodeToNameMap.NL },
  { value: caStateCode.NT, label: caStateCodeToNameMap.NT },
  { value: caStateCode.NS, label: caStateCodeToNameMap.NS },
  { value: caStateCode.NU, label: caStateCodeToNameMap.NU },
  { value: caStateCode.ON, label: caStateCodeToNameMap.ON },
  { value: caStateCode.PE, label: caStateCodeToNameMap.PE },
  { value: caStateCode.QC, label: caStateCodeToNameMap.QC },
  { value: caStateCode.SK, label: caStateCodeToNameMap.SK },
  { value: caStateCode.YT, label: caStateCodeToNameMap.YT }
]
